import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import SegmentedTabs from '../../../reusable/SegmentedTabs/SegmentedTabs';
import { selectUser } from '../../../store/slices/authSlice';
import { t } from '../../../i18n/i18n';
import './IdentityVerification.scss';

const TABS = [
  { value: '/verification/identity', label: 'KYC Verification' },
  // Hidden for now — not needed yet, kept for when it is. Restore this line,
  // the route in router.js and the crumb in breadcrumbs.js together.
  // { value: '/verification/identity/documents', label: 'Document Verification' },
];

/**
 * Verification — two separate checks under one heading: KYC Verification (the
 * Veriff identity check) and Document Verification (the photo ID + proof of
 * address review). Each tab is its own route, so a link can land on either,
 * and the tabs follow the path in both directions.
 *
 * The header is the original Verification page's, word for word.
 */
export default function IdentityVerification() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const name = useSelector(selectUser)?.name || null;

  const current = TABS.find((tab) => tab.value === pathname)?.value ?? TABS[0].value;

  return (
    <div className="identity">
      <header className="pv-head">
        <div>
          <h1>{t('Verification')}</h1>
          <p>
            {t('Confirm your identity once so you can request performance fees. The same check applies to every account on {{name}}.', { name: name ?? t('your profile') })}
          </p>
        </div>

        {/* A single tab is no choice at all, so the strip only shows with
            two or more (Document Verification is commented out above). */}
        {TABS.length > 1 && (
          <SegmentedTabs
            className="identity-tabs"
            value={current}
            onChange={(to) => navigate(to)}
            options={TABS.map((tab) => ({
              value: tab.value,
              label: t(tab.label),
            }))}
          />
        )}
      </header>

      <Outlet />
    </div>
  );
}
